<template>
  <v-container class="px-8 py-5">
    <v-row class="body-2 font-weight-light justify-space-between">
      <div>
        <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <span>{{$todayDate()}}</span>
    </v-row>
    <v-row class="justify-center pt-6 ma-0">
      <v-col cols="12" md="8" sm="10" class="pa-0">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-card
              outlined
              class="pa-4"
              v-if="schoolPlan.id"
            >
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-h6">Osnovni podaci</v-col>
              </v-row>
              <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Naziv nastavnog plana: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      outlined
                      hide-details
                      v-model="planTitle"
                      height="44"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Razred: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      :items="classes"
                      hide-details
                      item-text="text"
                      item-value="id"
                      v-model="planClass"
                      outlined
                      height="44"
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Smjer: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-treeview
                      v-if="educationalFields"
                      :items="filteredEduFields"
                      open-on-click
                      ref="treeview"
                      selection-type="independent"
                    >
                      <template slot="prepend" slot-scope="props">
                        <v-checkbox
                          dense
                          hide-details
                          v-if="!props.item.children"
                          v-model="props.item.selected"
                          @click="setSelected(props.item)"
                        >
                        </v-checkbox>
                      </template>
                    </v-treeview>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Škola: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      placeholder="Odaberite školu"
                      hide-details
                      :items="schools"
                      item-value="id"
                      item-text="name"
                      v-model="schoolId"
                      outlined
                      height="44"
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="flex-column">
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col class="pt-4">
                    <v-btn
                      block
                      height="44"
                      class="primary elevation-0"
                      @click="updateSchoolPlan"
                    >Potvrdi</v-btn>
                  </v-col>
                </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="subjectGroups.length > 0" class="justify-center mt-4">
          <v-expansion-panels accordion>
            <v-expansion-panel
              v-for="group in subjectGroups"
              :key="group.id"
            >
              <v-expansion-panel-header hide-actions>
                <v-row>
                  <v-col cols="5">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="mb-2">
                          <span class="font-weight-light">Naziv grupe: </span>
                          <span>{{ group.title }}</span>
                        </v-list-item-title>
                        <v-list-item-title>
                          <span class="font-weight-light">Izborna grupa: </span>
                          <span>{{ (group.optional === 1) ? 'Da' : 'Ne' }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="5">
                    <div class="d-flex align-center" style="height: 100%">
                      <span class="font-weight-light">Broj predmeta: </span>
                      <span>{{(group.subjects) ? group.subjects.length : 0}}</span>
                    </div>
                  </v-col>
                  <v-col cols="2" class="d-flex pa-0 justify-end">
                    <v-icon
                      class="mr-2"
                      color="primary"
                      size="20"
                      @click.stop="editDialog = true; currentGroup = group"
                    >mdi-pencil</v-icon>
                    <v-icon
                      color="red"
                      size="20"
                      @click.stop="deleteDialog = true; currentGroup = group"
                    >mdi-delete</v-icon>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="background-color: rgba(240, 245, 247, 0.5);" class="py-4">
                <v-row>
                  <v-col class="text-h6">Predmeti</v-col>
                </v-row>
                <v-row v-for="(subject, index) in group.subjects" :key="subject.d">
                  <v-col cols="6">
                    <v-row>
                      <v-subheader style="height: auto;">Naziv predmeta: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-autocomplete
                          :items="subjects"
                          placeholder="Odaberite predmet"
                          item-text="title"
                          item-value="id"
                          v-model="subject.id"
                          height="44"
                          dense
                          hide-details
                          outlined
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-subheader style="height: auto;">Sati: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-text-field
                          outlined
                          hide-details
                          height="44"
                          step="0.5"
                          dense
                          type="number"
                          v-model="subject.pivot.weekly_classes"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-subheader style="height: auto;">Praksa: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-text-field
                          outlined
                          hide-details
                          height="44"
                          step="0.5"
                          dense
                          type="number"
                          v-model="subject.pivot.weekly_classes_practice"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col class="pb-0 pt-7">
                        <v-btn
                          height="44"
                          style="min-width: 44px; width: 44px"
                          class="red darken-2 elevation-0"
                          @click="detachGroupSubjects(group, subject.id, index)"
                        >
                          <v-icon size="20" color="white">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-1"><v-divider></v-divider></v-col>
                </v-row>
                <v-row>
                  <v-btn
                    class="elevation-0 primary--text"
                    text
                    @click="addField(group.subjects)"
                  > + Dodaj polje</v-btn>
                </v-row>
                <v-row class="flex-column" v-if="group.subjects.length > 0">
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col>
                    <v-btn
                      block
                      height="44"
                      class="primary elevation-0"
                      @click="updateGroupSubjects(group.subjects, group.id)"
                    >Potvrdi</v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editDialog"
      width="500"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
            <v-toolbar-title>Uredite grupu</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn @click.native="editDialog = false" dark icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-row>
              <v-col cols="4">
                <v-subheader class="justify-end">Predmetna grupa: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  outlined
                  height="44"
                  dense
                  hide-details
                  v-model="currentGroup.title"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-subheader class="justify-end">Izborni: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-checkbox
                  v-model="currentGroup.optional"
                  height="44"
                  dense
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            height="44"
            depressed
            class="text-none"
            @click="editDialog = false"
          >
            Odustani
          </v-btn>
          <v-btn
            height="44"
            depressed
            class="primary text-none"
            @click="updateSubjectGroup"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
                primary-title>
            {{ dialogTitle }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
            {{ deleteText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteDialog = false" depressed large outlined>Odustani</v-btn>
            <v-btn @click="deleteSubjectGroup()" color="error" depressed large>Izbriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from '../../services/ApiV2'

export default {
  components: {
  },
data: () => ({
    schoolPlan: {},
    subjectGroupTitle: '',
    subjects: [],
    subjectGroups: [],
    educationalFields: [],
    planTitle: '',
    planClass: null,
    schools: [],
    selectedFields: [],
    currentGroup: {},
    schoolId: null,
    editDialog: false,
    deleteDialog: false,
    deleteText: 'Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
    dialogTitle: 'Jeste li sigurni?'
  }),
  computed: {
    classes() {
      let classNames = [{header: 'Osnovna škola'}]
      for(let i = 1; i <= 14; i++){
        if(i > 10) {
          classNames.push({id: i.toString(), text: `${i % 10}. razred - Srednja škola`})
        } else if(i !== 10) {
          classNames.push({id: i.toString(), text: `${i}. razred`});
        } else {
          classNames.push({divider: true})
          classNames.push({header: "Srednja škola"})
        }
      }
      return classNames;
    },

    filteredEduFields(){
      let data = this.educationalFields;

      if(+this.planClass < 10){
        return data.slice(0, 1);
      } else {
        return data.slice(1, 2);
      }
    },

    breadcrumbs() {
      return [
        {
          text: 'Nastavni planovi',
          disabled: false,
          exact: true,
          to: '/admin/nastavni_planovi',
        },
        {
          text: this.schoolPlan.title,
          disabled: false,
          exact: true,
          to: `/admin/nastavni_planovi/${this.schoolPlan.id}`,
        },
        {
          text: 'Uređivanje',
          disabled: true
        },
      ]
    }
  },
  methods: {
    setSelected(item) {
      const index = this.selectedFields.indexOf(item.id);
      if (index > -1) {
        this.selectedFields.splice(index, 1);
      }

      if(item.selected){
        this.selectedFields.push(item.id);
      }
    },

    preselectFields(field) {
      this.selectedFields.forEach(selected => {
        if(selected === field.id){
          field.selected = true;
        }
      })

      if(field.children){
        field.children.forEach(el => {
          this.preselectFields(el);
        })
      }
    },

    getSchools(){
      ApiV2.get('schools', {
        params: {
          perPage: -1
        }
      }).then(response => {
          this.schools = response.data.data;
          this.schools.unshift({name: 'Sve škole', id: null})
        })
        .catch(error => {
          console.log(error);
        })
    },
    getOnePlan() {
      ApiV2.get(`school_plans/${this.$route.params.id}`,
      {params: {with: ["subjectGroups.subjects" , "educationalFields", "school"]}})
        .then(response => {
          const {subject_groups, title, school_class, educational_fields, school} = response.data;
          this.schoolPlan = response.data;
          this.subjectGroups = subject_groups;
          this.schoolId = (school) ? school.id : null;
          this.planTitle = title;
          this.planClass = school_class;
          educational_fields.forEach(el => {
            this.selectedFields.push(el.id);
          });

          this.educationalFields.forEach(field => {
              this.preselectFields(field)
            })
        });
    },
    addField(subjects) {
      subjects.push({id: null, pivot: {weekly_classes: 0, weekly_classes_practice: 0}});
    },
    getSubjects() {
      ApiV2.get('subjects', {
        params: {
          perPage: -1
        }
      })
        .then(response => {
          this.subjects = response.data.data;
        });
    },
    getEducationalFields() {
      return new Promise((resolve) => {
        ApiV2.get('educational_fields', {
          params: {
            "filter[parent_id]": "n=",
            with: "children"
          }
        }).then(response => {
            this.educationalFields = response.data.data;
            
            resolve();
          });
        })
    },
    async getData(){
      await this.getEducationalFields();
      this.getOnePlan();
      this.getSubjects();
      this.getSchools();
    },

    detachGroupSubjects(group, subjectId, index) {
      const currentSubject = group.subjects[index]
      if(currentSubject.id === null || currentSubject.pivot.weekly_classes === null || currentSubject.pivot.weekly_classes_practice === null) {
        group.subjects.splice(index, 1);
      } else {
        ApiV2.post(`subject_groups/${group.id}/subjects`, {
          data: [subjectId],
          method: "detach"
        })
          .then((response) => {
            group.subjects = response.data.subjects;
            serverBus.$emit('show-snackbar', true, `Uspješno ste uklonili predmet.`);

          })
          .catch(() => {
            serverBus.$emit('show-snackbar', false);
          });
      }
    },
    deleteSubjectGroup() {
      ApiV2.delete(`subject_groups/${this.currentGroup.id}`)
      .then(() => {
          this.deleteDialog = false;
          this.getOnePlan();
          serverBus.$emit('show-snackbar', true, `Uspješno ste obrisali grupu "${this.currentGroup.title}"`);
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    },
    updateSchoolPlan(){
      ApiV2.put(`school_plans/${this.schoolPlan.id}`, {
        title: this.planTitle,
        school_class: this.planClass,
        school_id: this.schoolId,
        school_year_id: this.schoolPlan.school_year_id,
        relations: {
            educationalFields: {
                data: this.selectedFields,
                method: "sync"
            }
        }
      }).then((response) => {
          this.schoolPlan = response.data;
          serverBus.$emit('show-snackbar', true, `Uspješno ste ažurirali podatke.`);
          this.$router.push(`/admin/nastavni_planovi/${this.schoolPlan.id}`);
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    },
    updateSubjectGroup() {
      ApiV2.put(`subject_groups/${this.currentGroup.id}`, {
        school_plan_id: this.schoolPlan.id,
        title: this.currentGroup.title,
        optional: this.currentGroup.optional
      }).then(() => {
          this.getOnePlan()
          this.editDialog = false
          serverBus.$emit('show-snackbar', true, `Uspješno ste ažurirali grupu.`);
        })
        .catch((error) => {
          if (error.response.status == 422) {
            for (let key in error.response.data.errors) {
                serverBus.$emit('show-snackbar', false, error.response.data.errors[key][0]);
            }
          } else {
            serverBus.$emit('show-snackbar', false);
          }
        });
    },
    updateGroupSubjects(subjects, groupId){
      const dataObject = {};

      subjects.map(item => {
        Object.assign(dataObject, {[item.id]: {weekly_classes: parseFloat(item.pivot.weekly_classes).toFixed(2), weekly_classes_practice: parseFloat(item.pivot.weekly_classes_practice).toFixed(2)}})
      })

      ApiV2.post(`subject_groups/${groupId}/subjects`, {
        data: dataObject,
        method: "sync"
      }).then(() => {
          serverBus.$emit('show-snackbar', true, `Uspješno ste ažurirali listu predmeta.`);
          this.$router.push(`/admin/nastavni_planovi/${this.schoolPlan.id}`);
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
